import { routes as grupospermissoes } from '../gestaousuarios/grupospermissoes';
import { routes as usuariosgrupos } from '../gestaousuarios/usuariosgrupos';

export default [
  {
    path: '/gestaousuarios',
    name: 'Gestão de Usuários',
    description: 'Módulo Gestão de Usuários',
    children: [...grupospermissoes, ...usuariosgrupos],
    goesToMenu: true,
  },
];
